<template>
	<div class="rowSectionItem">
		<AccessoriesModal
			:is-show="isShowAccessories"
			:value="section.accessories"
			:separate="separate"
			:can-back-screen="canBackScreen"
			:can-side-screen="canSideScreen"
			:count="section.count"
			@close="isShowAccessories = false"
			@input="section.accessories = $event"
		/>
		<div class="rowSectionItem-head">
			<div class="rowSectionItem-number">{{ number + 1 }}</div>
			<a class="rowSectionItem-remove" @click.prevent="$emit('remove')" href="#" title="Удалить"></a>
		</div>
		<RowSectionForm class="rowSectionItem-form" v-if="isEdit" @submit="update" :data="editData"></RowSectionForm>
		<div class="rowSectionItem-body" v-else>
			<ul class="rowSectionItem-params">
				<li :class="{'rowSectionItem-additional': !isPrimary}">Нагрузка, кг: {{ capacity }}</li>
				<!-- <li :class="{'rowSectionItem-additional': !isPrimary}">Высота, мм: {{ height }}</li>
				<li :class="{'rowSectionItem-additional': !isPrimary}">Глубина, мм: {{ depth }}</li> -->
				<li>Ширина, мм: {{ section.width }}</li>
				<li>Ярусов: {{ section.count }}</li>
			</ul>
			<div class="rowSectionItem-foot">
				<a href="#" class="rowSectionItem-edit" @click.prevent="edit" title="Редактировать"></a>
				<a href="#" class="rowSectionItem-settings" title="Аксессуары" @click.prevent="showAccessories"></a>
				<a href="#" class="rowSectionItem-copy" @click.prevent="$emit('copy')" title="Копировать стеллаж"></a>
			</div>
			<div class="rowSectionItem-svgHolder" :style="{height: svgHeight + 'px'}"></div>
		</div>
	</div>
</template>

<script>
	import RowSectionForm from './RowSectionForm.vue';
	import AccessoriesModal from './AccessoriesModal.vue';

	export default {
		props: {
			svgHeight: Number,
			number: Number,
			separate: Boolean,
			capacity: Number,
			height: Number,
			depth: Number,
			section: Object,
			racksType: String,
		},
		data() {
			return {
				isEdit: false,
				isShowAccessories: false,
			};
		},
		created() {
			if (this.section.justCreatedFirstSection) {
				this.isEdit = true
				this.section.justCreatedFirstSection = false
			}
		},
		computed: {
			isPrimary() {
				return (this.number === 0);
			},
			editData() {
				return {
					capacity: this.capacity,
					height: this.height,
					depth: this.depth,
					width: this.section.width,
					count: this.section.count,
					shelvesType: this.section.shelvesType,
					beamsType: this.section.beamsType,
					coupler: this.section.coupler,
					racksType: this.racksType,
				};
			},
			canBackScreen() {
				return this.checkWidthBackScreen(this.section.width)
			},
			canSideScreen() {
				return this.checkDepthBackScreen(this.depth)
			},
		},
		methods: {
			edit() {
				this.isEdit = true;
			},
			showAccessories() {
				this.isShowAccessories = true;
			},
			checkWidthBackScreen(width) {
				return [900, 1200, 1500, 1800, 2100].includes(+width);
			},
			checkDepthBackScreen(depth) {
				return [600, 800, 1000].includes(+depth);
			},
			update(data) {
				if (this.checkWidthBackScreen(data.width) === false) {
					if (this.section.accessories.back_screen_count > 0) {
						this.section.accessories.back_screen = false
						this.section.accessories.back_screen_count = 0
						setTimeout(() => {
							alert("Для данной секции убран задний экран, т.к.\nзадние экраны могут быть добавлены только для секций с шириной:\n 900/1200/1500/1800/2100")
						}, 10)
					}
				}
				this.$emit('update', data);
				this.isEdit = false;
			},
		},
		components: {
			RowSectionForm,
			AccessoriesModal,
		},
	}
</script>

<style scoped>
	.rowSectionItem {
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		padding: 0 16px;
		border-right: 1px solid #DDDDDD;
	}
	.rowSectionItem-head {
		margin-bottom: 24px;
		display: flex;
		align-items: center;
	}
	.rowSectionItem-form {
		flex-grow: 1;
		overflow: visible;
		position: relative;
		margin: 0 -16px;
		padding: 0 16px;
		z-index: 1;
		background: white;
	}
	.rowSectionItem-body {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		min-height: 660px;
	}
	.rowSectionItem-foot {
		margin-bottom: 16px;
	}
	.rowSectionItem-number {
		margin-right: 8px;
		width: 34px;
		height: 34px;
		line-height: 34px;
		text-align: center;
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		font-size: 18px;
		text-transform: uppercase;
		color: #0A53B3;
		background: #F6F6F6;
	}
	.rowSectionItem-title {
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		font-size: 14px;
		text-transform: uppercase;
		color: #A7A7A7;
	}
	.rowSectionItem-params {
		margin: 0 0 12px;
		padding: 0;
		list-style: none;
		font-size: 14px;
	}
	.rowSectionItem-params > li {
		margin-bottom: 8px;
	}
	.rowSectionItem-additional {
		color: #A7A7A7;
	}
	.rowSectionItem-remove {
		display: inline-block;
		margin-left: auto;
		width: 10px;
		height: 10px;
		background: url(../../public/icons/cross.svg) no-repeat center center;
	}
	.rowSectionItem-settings {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/settings.svg) no-repeat center center;
	}
	.rowSectionItem-edit {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/edit.png) no-repeat center center;
	}
	.rowSectionItem-copy {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/copy.svg) no-repeat center center;
	}
</style>